import funcTabRouteList from './funcTabRouteList';

export default function (pathName, givenRouteList) {
  let baseName, routeList;

  if (givenRouteList) {
    // admin 子功能清單
    routeList = givenRouteList;
  } else {
    // 包含"/"可有效降低衝突機會
    baseName = '/salesky/';
    // 主功能清單，需注意路由名稱衝突
    routeList = funcTabRouteList;
  }

  const len = routeList.length;

  if (baseName) {
    // pathName前處理，縮小範圍至主功能route name，避免名稱衝突造成誤判
    // 先找到baseName，然後取至下一個"/"之前的字串
    const nameLength = baseName.length,
      startInd = pathName.indexOf(baseName) + nameLength,
      endInd = pathName.indexOf('/', startInd),
      funcName = pathName.slice(
        startInd,
        // 無"/"尾的情況處理
        endInd === -1 ? pathName.length : endInd
      );

    for (let i = 0; i < len; i++) {
      // 比對list看是否為有效主功能路由名稱
      if (funcName === routeList[i]) return routeList[i];
    }
  } else {
    for (let i = 0; i < len; i++) {
      if (pathName.indexOf(routeList[i]) !== -1) return routeList[i];
    }
  }

  return -1;

}


// WEBPACK FOOTER //
// ./src/commonJS/getFuncTabRoute.js